var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import { createPortal } from 'react-dom';
import useResetToDefaultPosition from '../hooks/useResetToDefaultPosition';
import { useOpenLayers } from '../react-ol';
import styled from 'styled-components';
var icon = "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1zZXR0aW5nc19iYWNrdXBfcmVzdG9yZS0yNHB4XzFfIiBkYXRhLW5hbWU9InNldHRpbmdzX2JhY2t1cF9yZXN0b3JlLTI0cHggKDEpIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PHBhdGggaWQ9Imljb24tUGF0aF85ODIxIiBkYXRhLW5hbWU9IlBhdGggOTgyMSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGlkPSJpY29uLVBhdGhfOTgyMiIgZGF0YS1uYW1lPSJQYXRoIDk4MjIiIGQ9Ik0xNCAxMmEyIDIgMCAxMC0yIDIgMi4wMDYgMi4wMDYgMCAwMDItMnptLTItOWE5IDkgMCAwMC05IDlIMGw0IDQgNC00SDVhNyA3IDAgMTEyLjk0IDUuN2wtMS40MiAxLjQ0QTkgOSAwIDEwMTIgM3oiIGZpbGw9IiMwYjFmM2MiLz48L3N2Zz4=";
var Button = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: 'Open Sans', sans-serif;\n  font-size: 1.6rem;\n  background-color: ", ";\n  border-radius: 0.4rem;\n  height: 3.6rem;\n  width: 3.6rem;\n  border: 0.1rem solid ", ";\n  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.16);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  text-align: center;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n  img {\n    max-width: 2.4rem;\n  }\n"])), _ref => {
  var {
    theme
  } = _ref;
  return theme.colors.background;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.colors.border;
});
export var ResetPosition = _ref3 => {
  var {
    duration,
    padding
  } = _ref3;
  var {
    resetPositionTargetRef
  } = useOpenLayers();
  var resetToDefaultPosition = useResetToDefaultPosition();
  return resetPositionTargetRef !== null && resetPositionTargetRef !== void 0 && resetPositionTargetRef.current ? /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(Button, {
    title: "Reset to default position",
    onClick: () => resetToDefaultPosition({
      duration,
      padding
    })
  }, /*#__PURE__*/React.createElement("img", {
    src: icon,
    alt: "Reset to default position"
  })), resetPositionTargetRef.current) : null;
};